/** Load `path` afresh, dropping every cached query and in-memory state (e.g. after switching identity). */
export function reloadAt(path: string): void {
  window.location.assign(path);
}
